<template>
  <header class="header" :class="{ hidden: isHidden }">
    <div class="header_content">
      <Logo @click="$router.push({ name: 'Feed' })" />
      <img src="/LogoIcon.svg" class="mini-logo" @click="$router.push({ name: 'Feed' })" />

      <Search v-if="auth.user" />

      <div class="header__btn_box">
        <ThemeSwitcher></ThemeSwitcher>

        <MiniProfile v-if="auth.user" />

        <button v-else @click="$router.push({ name: 'Login' })" class="header__login_btn">
          {{ $t('login.profile') }}
        </button>
      </div>
    </div>
  </header>
</template>

<script>
import ThemeSwitcher from "./ThemeSwitcher.vue";
import { useAuthStore } from "../stores/authStore";
import MiniProfile from "./Profile/MiniProfile.vue";
import Search from "./Search.vue";
import Logo from "../UI/Logo.vue";

export default {
  components: { ThemeSwitcher, MiniProfile, Search, Logo },
  name: "Header",
  data() {
    return {
      lastScroll: 0,
      isHidden: false,
      auth: useAuthStore()
    };
  },
  methods: {
    handleScroll() {
      const currentScroll = window.scrollY;
      if (currentScroll > this.lastScroll && currentScroll > 60) {
        this.isHidden = true;
      } else {
        this.isHidden = false;
      }
      this.lastScroll = currentScroll;
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style>
.header {
  background-color: var(--header-color);
  color: #ffffff;
  height: 56px;
  width: 100%;
  border-bottom: 1px solid var(--border-color);
  display: flex;
  position: fixed;
  top: 0;
  z-index: 5;
  justify-content: center;
  align-items: center;
  transition: transform 0.3s ease, background-color var(--transition-time) ease,
    border-bottom var(--transition-time) ease;
}

.header.hidden {
  transform: translateY(-100%);
}

.header_content {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  text-align: center;
  align-items: center;
  margin: 0 48px;
}

.mini-logo {
  display: none;
  cursor: pointer;
}

.header__login_btn {
  height: 100%;
  background-color: rgba(0, 0, 0, 0);
  color: var(--text-color);
  font-weight: 600;
  cursor: pointer;
}

.header__login_btn:hover {
  color: var(--hover);
}

.header__btn_box {
  display: flex;
  align-items: center;
  height: 100%;
  gap: 16px;
}

@media (max-width: 500px) {
  .header_content {
    margin: 0 8px;
    gap: 8px;
  }

  .header__btn_box {
    display: flex;
    gap: 8px;
  }

  .search_input input {
    width: 100%;
  }

  .header_content .logo {
    display: none;
  }

  .mini-logo {
    display: block;
  }

  .header__login_btn {
    padding: 0 10px;
  }
}
</style>
